export default "__VITE_ASSET__7XAqa$Eh__"